<div class="pt-6">
        <dt>
            <button (click)="toggle()" type="button" class="flex w-full items-start justify-between text-left text-normal" aria-controls="faq-0" aria-expanded="false">
                <span class="text-base/7 font-semibold" >{{question?.question.value}}</span>
                <span class="ml-6 flex h-7 items-center">
                <svg class="h-6 w-6" [ngClass]="{
                    'hidden': question?.opened
                }" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
                </svg>
                <svg [ngClass]="{
                    'hidden': !question?.opened
                }" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
                </svg>
              </span>
            </button>
        </dt>
        <dd [ngClass]="{
            'hidden' : !question?.opened
        }" class="mt-2 pr-12" id="faq-0">
            <p class="text-base/7 text-gray-300">{{question?.answer.value}}</p>
        </dd>
</div>
